export const TAB_CONTENT = 0;
export const TAB_PRODUCT = 1;
export const SEARCH_PAGE_SIZE = 12;
